<template>
  <div id="dashboard-analytics">
    <vs-button ref="loadableButton" id="button-with-loading" class="vs-con-loading__container mt-2"
      @click="getCreditPopup()" type="relief" style="float: none !important;">Get Vehicle Details</vs-button>

    <vs-collapse class="mt-base" type="margin" accordion>
      <vs-collapse-item v-for="(vehicle, i) in vehicleDetails" :key="i">
        <div slot="header">Vehicle {{ i + 1 }}</div>

        <div class="vx-row mt-2 border-common border-primary"
          style="margin-left:10px;margin-right:10px;margin-bottom:10px">
          <div class="vx-col w-full lg:w-1/2">
            <table>
              <tr>
                <td>Vehicle RegNO</td>
                <td>{{ vehicle.data.regNo }}</td>
              </tr>
              <tr>
                <td>Class</td>
                <td>{{ vehicle.data.class }}</td>
              </tr>
              <tr>
                <td>Chassis</td>
                <td>{{ vehicle.data.chassis }}</td>
              </tr>
              <tr>
                <td>Engine</td>
                <td>{{ vehicle.data.engine }}</td>
              </tr>
              <tr>
                <td>Vehicle Manufacturer Name</td>
                <td>{{ vehicle.data.vehicleManufacturerName }}</td>
              </tr>
              <tr>
                <td>Model</td>
                <td>{{ vehicle.data.model }}</td>
              </tr>
              <tr>
                <td>Vehicle Colour</td>
                <td>{{ vehicle.data.vehicleColour }}</td>
              </tr>
              <tr>
                <td>Type</td>
                <td>{{ vehicle.data.type }}</td>
              </tr>
              <tr>
                <td>Norms Type</td>
                <td>{{ vehicle.data.normsType }}</td>
              </tr>
              <tr>
                <td>Body Type</td>
                <td>{{ vehicle.data.bodyType }}</td>
              </tr>
              <tr>
                <td>Owner Count</td>
                <td>{{ vehicle.data.ownerCount }}</td>
              </tr>
              <tr>
                <td>Owner</td>
                <td>{{ vehicle.data.owner }}</td>
              </tr>
              <tr>
                <td>Owner Father Name</td>
                <td>{{ vehicle.data.ownerFatherName }}</td>
              </tr>
              <tr>
                <td>Vehicle Cubic Capacity</td>
                <td>{{ vehicle.data.vehicleCubicCapacity }}</td>
              </tr>

              <tr>
                <td>Unladen Weight</td>
                <td>{{ vehicle.data.unladenWeight }}</td>
              </tr>
              <tr>
                <td>Vehicle Category</td>
                <td>{{ vehicle.data.vehicleCategory }}</td>
              </tr>
              <tr>
                <td>rc StandardCap</td>
                <td>{{ vehicle.data.rcStandardCap }}</td>
              </tr>
              <tr>
                <td>Vehicle Cylinders No</td>
                <td>{{ vehicle.data.vehicleCylindersNo }}</td>
              </tr>
              <tr>
                <td>Vehicle Seat Capacity</td>
                <td>{{ vehicle.data.vehicleSeatCapacity }}</td>
              </tr>
              <tr>
                <td>Blacklist Details</td>

                <td>
                  <ul>
                    <li v-for="(companynum, index) in vehicle.data
                      .blacklistDetails">
                      {{ companynum }}
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>Challan Details</td>

                <td>
                  <ul>
                    <li v-for="(companynum, index) in vehicle.data.challanDetails">
                      {{ companynum }}
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>Permit Issue Date</td>
                <td>{{ vehicle.data.permitIssueDate }}</td>
              </tr>
              <tr>
                <td>Permit Number</td>
                <td>{{ vehicle.data.permitNumber }}</td>
              </tr>
              <tr>
                <td>Permit Type</td>
                <td>{{ vehicle.data.permitType }}</td>
              </tr>

              <tr>
                <td>National Permit Number</td>
                <td>{{ vehicle.data.nationalPermitNumber }}</td>
              </tr>
              <tr>
                <td>National Permit Upto</td>
                <td>{{ vehicle.data.nationalPermitUpto }}</td>
              </tr>
            </table>
          </div>
          <div class="vx-col w-full lg:w-1/2">
            <table>
              <tr>
                <td>Vehicle Number</td>
                <td>{{ vehicle.data.vehicleNumber }}</td>
              </tr>
              <tr>
                <td>Is Commercial</td>
                <td>{{ vehicle.data.isCommercial }}</td>
              </tr>
              <tr>
                <td>Mobile Number</td>
                <td>{{ vehicle.data.mobileNumber }}</td>
              </tr>
              <tr>
                <td>Status</td>
                <td>{{ vehicle.data.status }}</td>
              </tr>
              <tr>
                <td>Status As On</td>
                <td>{{ vehicle.data.statusAsOn | moment("DD MMM, YYYY") }}</td>
              </tr>
              <tr>
                <td>Reg Authority</td>
                <td>{{ vehicle.data.regAuthority }}</td>
              </tr>
              <tr>
                <td>Reg Date</td>
                <td>{{ vehicle.data.regDate }}</td>
              </tr>
              <tr>
                <td>Vehicle Manufacturing Month Year</td>
                <td>{{ vehicle.data.vehicleManufacturingMonthYear }}</td>
              </tr>
              <tr>
                <td>rc ExpiryDate</td>
                <td>
                  {{ vehicle.data.rcExpiryDate | moment("DD MMM, YYYY") }}
                </td>
              </tr>
              <tr>
                <td>Vehicle Tax Upto</td>
                <td>
                  {{ vehicle.data.vehicleTaxUpto | moment("DD MMM, YYYY") }}
                </td>
              </tr>
              <tr>
                <td>Vehicle Insurance CompanyName</td>
                <td>{{ vehicle.data.vehicleInsuranceCompanyName }}</td>
              </tr>
              <tr>
                <td>Vehicle Insurance Upto</td>
                <td>{{ vehicle.data.vehicleInsuranceUpto }}</td>
              </tr>
              <tr>
                <td>Vehicle Insurance Policy Number</td>
                <td>{{ vehicle.data.vehicleInsurancePolicyNumber }}</td>
              </tr>
              <tr>
                <td>rc Financer</td>
                <td>{{ vehicle.data.rcFinancer }}</td>
              </tr>
              <tr>
                <td>Gross Vehicle Weight</td>
                <td>{{ vehicle.data.grossVehicleWeight }}</td>
              </tr>

              <tr>
                <td>Vehicle Sleeper Capacity</td>
                <td>{{ vehicle.data.vehicleSleeperCapacity }}</td>
              </tr>
              <tr>
                <td>Vehicle Standing Capacity</td>
                <td>{{ vehicle.data.vehicleStandingCapacity }}</td>
              </tr>
              <tr>
                <td>pucc Number</td>
                <td>{{ vehicle.data.puccNumber }}</td>
              </tr>

              <tr>
                <td>pucc Upto</td>
                <td>{{ vehicle.data.puccUpto }}</td>
              </tr>
              <tr>
                <td>Permit Valid From</td>
                <td>{{ vehicle.data.permitValidFrom }}</td>
              </tr>
              <tr>
                <td>Permit Valid Upto</td>
                <td>{{ vehicle.data.permitValidUpto }}</td>
              </tr>
              <tr>
                <td>Non Use Status</td>
                <td>{{ vehicle.data.nonUseStatus }}</td>
              </tr>
              <tr>
                <td>Non Use From</td>
                <td>{{ vehicle.data.nonUseFrom }}</td>
              </tr>
              <tr>
                <td>Non Use To</td>
                <td>{{ vehicle.data.nonUseTo }}</td>
              </tr>

              <tr>
                <td>NOC Details</td>
                <td>{{ vehicle.nocDetails }}</td>
              </tr>
              <tr>
                <td>National Permit IssuedBy</td>
                <td>{{ vehicle.data.nationalPermitIssuedBy }}</td>
              </tr>
            </table>
          </div>

          <div class="vx-col w-full">
            <div class="font-bold">
              Present Address
            </div>
            <table>
              <tr>
                <td>Address</td>
                <td>{{ vehicle.data.presentAddress }}</td>
              </tr>
            </table>
          </div>
          <div class="vx-row mt-2">
            <div class="vx-col w-full lg:w-1/2">
              <table>
                <tr>
                  <td>City</td>
                  <td>{{ vehicle.data.splitPresentAddress.city[0] }}</td>
                </tr>

                <tr>
                  <td>State</td>
                  <td>{{ vehicle.data.splitPresentAddress.state[0] }}</td>
                </tr>

                <tr>
                  <td>PinCode</td>
                  <td>{{ vehicle.data.splitPresentAddress.pincode }}</td>
                </tr>
              </table>
            </div>
            <div class="vx-col w-full lg:w-1/2">
              <table>
                <tr>
                  <td>District</td>
                  <td>{{ vehicle.data.splitPresentAddress.district[0] }}</td>
                </tr>

                <tr>
                  <td>Country</td>
                  <td>{{ vehicle.data.splitPresentAddress.country[2] }}</td>
                </tr>
              </table>
            </div>
          </div>

          <br />
          <div class="vx-col w-full">
            <div class="font-bold">
              Permanent Address
            </div>
            <table>
              <tr>
                <td>Address</td>
                <td>{{ vehicle.data.permanentAddress }}</td>
              </tr>
            </table>
          </div>
          <div class="vx-row mt-2">
            <div class="vx-col w-full lg:w-1/2">
              <table>
                <tr>
                  <td>City</td>
                  <td>{{ vehicle.data.splitPermanentAddress.city[0] }}</td>
                </tr>

                <tr>
                  <td>State</td>
                  <td>{{ vehicle.data.splitPermanentAddress.state[0] }}</td>
                </tr>

                <tr>
                  <td>PinCode</td>
                  <td>{{ vehicle.data.splitPermanentAddress.pincode }}</td>
                </tr>
              </table>
            </div>
            <div class="vx-col w-full lg:w-1/2">
              <table>
                <tr>
                  <td>District</td>
                  <td>{{ vehicle.data.splitPermanentAddress.district[0] }}</td>
                </tr>

                <tr>
                  <td>Country</td>
                  <td>{{ vehicle.data.splitPermanentAddress.country[2] }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </div>
</template>

<script>
import axios from "axios";
import Datepicker from "vuejs-datepicker";
export default {
  data() {
    return {
      date: "",
      task: "",
      tablist: [
        { text: "Open Date", value: "Open Date" },
        { text: "Current Balance", value: "Current Balance" },
        { text: "Amount Due", value: "Amount Due" }
      ],
      commentFlag: false,
      stageUpdateSuccess: "",
      stageUpdationSuccess: "",
      textSearched: "",
      companyNumbers: "",
      menuComment: "",
      custID: "",
      loginID: "",
      companyNumber: "",
      menuComment: "",
      kycName: "",
      dob: "",
      popupActive2: false,
      popupActive3: false,
      custdob: "",
      gender: "",
      email: "",
      monthly: "",
      educate: "",
      experience: "",
      address: "",
      accstatus: "",
      kstage: "",
      kycFullName: "",

      aadharno: "",
      panno: "",
      kloanlimit: "",
      mobileLoanLimit: "",
      newLoanLimit: "",
      clientDetails: "",
      companyname: "",
      regDate: "",
      regip: "",
      lastloginip: "",
      lastlogin: "",
      pincode: "",
      motherName: "",
      co: "",
      postOffice: "",
      createddate: "",
      photo: "",
      companyID: "",
      companyname: "",
      custData: "",
      vehicleID: "",
      rashmiLoginId: false,
      incomeData: "",
      swiggyApiPhoneNumber: false,
      profDataFlag: false,
      uberApiData: "",
      profileData: "",
      apiPhoneNumber: "",
      activationStatus: "",
      apiFirstName: "",
      apiLastName: "",
      apiNameVerifiedstr: "",
      apiNameVerified: "",
      companyNoVerified: "",
      companyNameVerified: "",
      custKycDetails: "",
      errorText: "",
      activeLogin: "",
      cAPSLast7Days: "",
      cAPSLast30Days: "",
      cAPSLast90Days: "",
      cAPSLast180Days: "",
      firstNameCredit: "",
      surnameCredit: "",
      genderCredit: "",
      dateOfBirthCredit: "",
      panNumberCredit: "",
      passportNumberCredit: "",
      phoneNumberCredit: "",
      emailidCredit: "",
      voterIdCredit: "",
      creditAccountTotal: "",
      creditAccountActive: "",
      creditAccountClosed: "",
      creditAccountDefault: "",
      emiAmountCredit: "",
      dateReported: "",
      bureauScore: "",
      bureauScoreConfidLevel: "",
      firstLineAddress: "",
      cityCredit: "",
      stateCredit: "",
      pinCodeCredit: "",
      outstandingBalanceAll: "",
      outstandingBalanceSecured: "",
      outstandingBalanceUnSecured: "",
      cAISAccountHistory: "",
      cityData: [],
      companyNames: [],
      cityNamesComp: [],
      accountDetailsNew: [],
      sortCredit: "",

      //credit bureau
      genderCode: 1,
      durationOfAgreement: 6,
      amountFinanced: 4000,
      loanTypeSelected: "Personal Loan",
      pinCodeCreditNew: "",
      lastNameCredit: "",

      stateSelected: "",
      creditBureauLogin: false,
      creditPanFlag: false,
      PancardCredit: "",
      accountTypeDescription: "",
      accountTypeDescriptionArray: [],
      qrcontractNote: "",
      qramount: "",
      qrtrxnRefId: "",
      firstNameCreditFlag: false,
      surnameCreditFlag: false,
      optionsStates: [
        {
          text: "Andaman and Nicobar Islands",
          value: "ANDAMAN and NICOBAR ISLANDS"
        },
        { text: "Andhra Pradesh", value: "ANDHRA PRADESH" },
        { text: "Arunachal Pradesh", value: "ARUNACHAL PRADESH" },
        { text: "Assam", value: "ASSAM" },
        { text: "Bihar", value: "BIHAR" },
        { text: "Chandigarh", value: "CHANDIGARH" },
        { text: "Chattisgarh", value: "CHHATTISGARH" },
        { text: "Dadra and Nagar Haveli", value: "DADRA and NAGAR HAVELI" },
        { text: "Daman and Diu ", value: "DAMAN and DIU" },
        { text: "Delhi", value: "DELHI" },
        { text: "Goa", value: "GOA" },
        { text: "Gujarat", value: "GUJARAT" },
        { text: "Haryana", value: "HARYANA" },
        { text: "Himachal Pradesh", value: "HIMACHAL PRADESH" },
        { text: "Jammu and Kashmir", value: "JAMMU and KASHMIR" },
        { text: "Jharkhand", value: "JHARKHAND" },
        { text: "Karnataka", value: "KARNATAKA" },
        { text: "Kerala", value: "KERALA" },
        { text: "Lakshadweep Islands", value: "LAKSHADWEEP" },
        { text: "Madhya Pradesh", value: "MADHYA PRADESH" },
        { text: "Maharashtra", value: "MAHARASHTRA" },
        { text: "Manipur", value: "MANIPUR" },
        { text: "Meghalaya", value: "MEGHALAYA" },
        { text: "Mizoram", value: "MIZORAM" },
        { text: "Nagaland", value: "NAGALAND" },
        { text: "Odisha", value: "ORRISA" },
        { text: "Pondicherry", value: "PONDICHERRY" },
        { text: "Punjab", value: "PUNJAB" },
        { text: "Rajasthan", value: "RAJASTHAN" },
        { text: "Sikkim", value: "SIKKIM" },
        { text: "Tamil Nadu", value: "TAMIL NADU" },
        { text: "Telangana", value: "TELANGANA" },
        { text: "Tripura", value: "TRIPURA" },
        { text: "Uttar Pradesh", value: "UTTAR PRADESH" },
        { text: "Uttarakhand", value: "UTTARANCHAL" },
        { text: "West Bengal", value: "WEST BENGAL" }
      ],
      currentCity: "",
      errorFlag: false,
      pinCodeCreditFlag: false,
      profileID: "",
      vehicleDetails: []
    };
  },
  components: {
    Datepicker
  },
  created() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      // true for mobile device
      this.isMobile = false;
    } else {
      // false for not mobile device
      this.isMobile = true;
    }

    this.commentFlag = true;
    this.stageUpdateSuccess = "";
    this.stageUpdationSuccess = "";
    this.vehicleDetails = this.$route.query.vehicleDetails;

    var searchText = this.$route.query.data;
    this.sendText = this.$route.query.sendText;
  },
  methods: {
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    resetSorting: function () {
      (this.accountTypeDescription = ""), (this.sortCredit = "");
    },

    getKYC() {
      var self = this;

      console.log("this is panno", self.custdob);
      if (self.panno === "") {
        self.creditPanFlag = true;
      }
      self.$store.commit("routeChange", "start");
      console.log("this is pan no", self.panno);
      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/kycservice/vehicle/",
        //   baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.28.53:8080/MintReliance/MintReliance/',
        headers: { "content-type": "application/json" }
      });

      //  var url = 'http://13.126.28.53:8080/MintReliance/MintReliance/kycCheck'
      var data = {
        client_id: "arcClientId",
        request_id: "arcRequestId1",
        requester_id: "ARC",
        service_provider_name: "1111",
        payload: {
          detailed: true,
          vehicleNo: "MH01AE8018"
        }
      };
      instance
        .post("vehicleRegistration", data)

        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          self.firstNameCredit = JSONData.firstName;
          self.surnameCredit = JSONData.surname;
          self.genderCredit = JSONData.gender;
          self.dateOfBirthCredit = JSONData.dateOfBirth;
          self.panNumberCredit = JSONData.panNumber;
          self.passportNumberCredit = JSONData.passportNumber;
          self.phoneNumberCredit = JSONData.phoneNumber;
          // self.emailidCredit =
          self.voterIdCredit = JSONData.voterId;
          self.creditAccountTotal = JSONData.creditAccountTotal;
          self.creditAccountActive = JSONData.creditAccountActive;
          self.creditAccountClosed = JSONData.creditAccountClosed;
          self.creditAccountDefault = JSONData.creditAccountDefault;
          self.dateReported = JSONData.reportDate;
          self.bureauScore = JSONData.bureauScore;
          self.bureauScoreConfidLevel = JSONData.bureauScoreConfidLevel;
          self.firstLineAddress = JSONData.firstLineAddress;
          self.cityCredit = JSONData.city;
          self.stateCredit = JSONData.state;
          self.stateSelected = self.stateCredit;
          self.pinCodeCredit = JSONData.pinCode;
          console.log("this is pincode", self.pinCodeCredit);
          if (self.pinCodeCredit === "" || self.pinCodeCredit === undefined) {
            self.pinCodeCreditFlag = true;
          }
          self.outstandingBalanceAll = JSONData.outstandingBalanceAll;
          self.outstandingBalanceSecured = JSONData.outstandingBalanceSecured;
          self.outstandingBalanceUnSecured =
            JSONData.outstandingBalanceUnSecured;
          self.cAPSLast7Days = JSONData.cAPSLast7Days;
          self.cAPSLast30Days = JSONData.cAPSLast30Days;
          self.cAPSLast90Days = JSONData.cAPSLast90Days;
          self.cAPSLast180Days = JSONData.cAPSLast180Days;
          self.enquiryDetails = JSONData.enquiryDetails;

          self.cityData = JSONData.accountDetails;
          self.companyNames = Object.keys(self.cityData);

          self.cityData.forEach(function (city) {
            if (
              !self.accountTypeDescriptionArray.includes(
                city.accountTypeDescription
              )
            ) {
              self.accountTypeDescriptionArray.push(
                city.accountTypeDescription
              );
            }
          });

          self.accountDetailsNew = self.cityData;

          for (var i = 0; i < self.companyNames.length; i++) {
            self.cityNamesComp = Object.keys(self.companyNames[i]);
            console.log("this are the keys", self.cityNamesComp);
          }

          self.$store.commit("routeChange", "end");
          self.progress = false;
        })
        .catch(function (error) {
          self.errorFlag = true;
          self.errorText = error.response.data.error;
          self.$store.commit("routeChange", "end");
        });
    },
    AccountHistory: function (city) {
      this.cAISAccountHistory = city.cAISAccountHistory;
      console.log("loan rpay info ", this.cAISAccountHistory);
      this.popupActive2 = true;
    },
    getCreditPopup: function () {
      this.popupActive3 = true;
    },
    switchToTwelveRequest: function () {
      var self = this;
      self.$store.commit("routeChange", "start");
      if (self.gender === "female") {
        self.genderCode = 2;
      } else if (self.gender === "other") {
        self.genderCode = 3;
      } else {
        self.genderCode = 1;
      }
      var panDet;
      if (self.creditPanFlag === true) {
        panDet = self.panNumberCredit.toUpperCase();
      } else {
        panDet = self.panno;
      }
      console.log("this is pan no", self.panno);
      const instance = axios.create({
        baseURL:
          "https://uatgateway.supermoney.in/credit-score/services/creditscore/",
        //   baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.28.53:8080/MintReliance/MintReliance/',
        headers: { "content-type": "application/json" }
      });

      //  var url = 'http://13.126.28.53:8080/MintReliance/MintReliance/kycCheck'
      var data = {
        referenceType: "Customer",
        customerId: self.$route.query.data,
        financialPurpose: self.loanTypeSelected,
        amountFinanced: self.amountFinanced,
        durationOfAgreement: self.durationOfAgreement,
        surname: self.surnameCredit,
        firstName: self.firstNameCredit,
        genderCode: self.genderCode,
        panNumber: self.panno,
        panIssueDate: "",
        panExpirationDate: "",
        dateOfBirth: self.$moment(self.custdob).format("YYYY-MM-DD"),
        firstLineAddress: self.address,
        secondLineAddress: "",
        city: self.currentCity,
        state: self.stateSelected,
        pinCode: self.pinCodeCredit,
        phoneNumber: self.loginID
      };
      instance
        .post("getCreditScore", data)

        .then(function (response) {
          console.log(response);
          const JSONData = response.data;
          self.popupActive3 = false;
          self.switchToTwelve();
          // if (JSONData.successFlag == true) {
          //
          //
          //     self.errorText = ''
          //     self.switchTabFive()
          //
          //
          //
          // }
          //
          // else {
          //     self.errorText = JSONData.data.message;
          //
          // }

          self.$store.commit("routeChange", "end");
          self.progress = false;
        })
        .catch(error => {
          self.errorText = "Data not found";
          console.log("display Error" + error);
          self.$store.commit("routeChange", "end");
        });
    },
    switchToTwelve: function () {
      this.$store.commit("routeChange", "start");
      console.log("this is first tab");
      this.commentFlag = true;
      this.stageUpdateSuccess = "";
      this.stageUpdationSuccess = "";
      var searchText = this.$route.query.data;
      this.textSearched = searchText;
      var timestamp = Math.round(+new Date() / 1000);
      var userip = this.$store.getters.ipAddress;
      var data = {
        customerID: this.$route.query.data
      };
      var msgHeader = {
        authToken: localStorage.getItem("authtoken"), //dynamic
        authLoginID: this.$store.getters.loginId,
        timestamp: timestamp,
        ipAddress: userip
      };
      var employeeKycDetails = { data, msgHeader };
      axios
        .post("mlGetCustomerDetails", employeeKycDetails)
        .then(response => {
          const JSONData = response.data;
          if (JSONData.data.error == 0) {
            this.$store.commit("setauthtoken", {
              authtoken: JSONData.msgHeader.authToken
            });
            localStorage.setItem("authtoken", JSONData.msgHeader.authToken);
            this.companyNumbers = JSONData.data.companyNumbers;
            this.menuComment = JSONData.data.custCredentials.comments;
            console.log("display Length == " + this.companyNumbers.length);
            this.custID = JSONData.data.custCredentials.customerID;
            this.loginID = JSONData.data.custCredentials.loginID;
            this.companyNumber = JSONData.data.custDetails.companyNumber;
            this.kycName = JSONData.data.custKycDetails.name;
            if (JSONData.data.custKycDetails.length != 0) {
              this.dob = JSONData.data.custKycDetails.dob;
            } else {
              this.dob = JSONData.data.custDetails.dateOfBirth;
            }
            this.custdob = JSONData.data.custDetails.dateOfBirth;
            this.gender = JSONData.data.custDetails.gender;
            this.email = JSONData.data.custDetails.emailID;
            this.monthly = JSONData.data.custDetails.monthlyIncome;
            this.educate = JSONData.data.custDetails.education;
            this.experience = JSONData.data.custDetails.workExperience;
            this.address = JSONData.data.custDetails.address;
            this.accstatus = JSONData.data.custCredentials.accountStatus;
            this.kstage = JSONData.data.custCredentials.stage;
            this.kycFullName = JSONData.data.custKycDetails.name;

            this.aadharno = JSONData.data.custKycDetails.aadharNO;
            this.panno = JSONData.data.custPanNumber;
            this.kloanlimit = JSONData.data.loanLimit;
            this.mobileLoanLimit = JSONData.data.mobileLoanLimit;
            this.newLoanLimit = JSONData.data.loanLimit;
            this.clientDetails = JSONData.data.clientDetails;
            this.companyname = JSONData.data.custDetails.companyName;
            this.regDate = JSONData.data.custCredentials.createdDate;
            this.regip = JSONData.data.custCredentials.registeredIpAddress;
            this.lastloginip =
              JSONData.data.custCredentials.lastLoggedInIpAddress;
            this.lastlogin = JSONData.data.custCredentials.lastLogin;
            this.pincode = JSONData.data.custKycDetails.pinCode;
            this.motherName = JSONData.data.custKycDetails.mothersName;
            this.co = JSONData.data.custKycDetails.fathersName;
            this.postOffice = JSONData.data.custKycDetails.postOffice;
            this.createddate = JSONData.data.custKycDetails.createdDate;
            this.photo = JSONData.data.custKycDetails.photo;
            this.companyID = JSONData.data.custDetails.companyID;
            this.currentCity = JSONData.data.custDetails.currentCity;
            if (this.companyname === "UDAAN") {
              this.custData = JSON.parse(
                JSONData.data.custDetails.customerData
              );
              this.vehicleID = this.custData.vehicalId;
            }
            if (
              this.$store.state.loginId === "rashmi.nandanvar@mintwalk.com" ||
              this.$store.state.loginId === "admin@mintloan.com" ||
              this.$store.state.loginId === "nazmeen@supermoney.in"
            ) {
              this.rashmiLoginId = true;
            }
            if (JSONData.data.incomeData.length > 0) {
              this.incomeData = JSONData.data.incomeData[0];
              this.swiggyApiPhoneNumber = true;
              console.log("this is the swiggy api", this.swiggyApiPhoneNumber);
            }

            if (JSONData.data.incomeData[0].profdata.length > 0) {
              this.profDataFlag = true;
              if (this.profDataFlag) {
                this.uberApiData = "available";
              } else {
                this.uberApiData = "not available";
              }
              this.profileData = JSONData.data.incomeData[0].profdata;
              this.apiPhoneNumber =
                JSONData.data.incomeData[0].profdata[0].phoneNumber;
              this.activationStatus =
                JSONData.data.incomeData[0].profdata[0].activationStatus;
              this.apiFirstName =
                JSONData.data.incomeData[0].profdata[0].firstName;
              this.apiLastName =
                JSONData.data.incomeData[0].profdata[0].lastName;
              this.apiNameVerifiedstr =
                JSONData.data.incomeData[0].profdata[0].confirmedCustomerID;
              this.apiNameVerified = Number(this.apiNameVerifiedstr);
              console.log(
                "this is the api verified name value",
                this.apiNameVerified
              );
              if (this.apiNameVerified > 0) {
                this.apiNameVerified = "1";
                console.log(
                  "this is the api verified name value",
                  this.apiNameVerified
                );
              } else if (this.apiNameVerifiedstr === "0") {
                this.apiNameVerified = "0";
                console.log(
                  "this is the api verified name value",
                  this.apiNameVerified
                );
              } else {
                this.apiNameVerified = "";
                console.log(
                  "this is the api verified name value",
                  this.apiNameVerified
                );
              }
            }

            //    console.log("this is the profile data",this.apiPhoneNumber)

            this.companyNoVerified = JSONData.data.custDetails.numberVerified;
            this.companyNameVerified = JSONData.data.custDetails.nameVerified;
            this.custKycDetails = JSONData.data.custKycDetails;
            this.errorText = "";
            if (JSONData.data.custKycDetails.length != 0) {
              this.dob = JSONData.data.custKycDetails.dob;
            } else {
              this.dob = JSONData.data.custDetails.dateOfBirth;
            }
            this.custdob = JSONData.data.custDetails.dateOfBirth;

            console.log("Name verified==" + this.companyNameVerified);
            console.log("Name verified==", this.aadharDoc);
          } else if (JSONData.msgHeader.authToken === "") {
            this.error = JSONData.data.message;
            this.$store.commit("setloginId", {
              loginid: ""
            });
            this.$store.commit("setauthtoken", {
              authtoken: ""
            });

            this.$root.$emit("logout");
          } else {
            this.errorText = JSONData.data.message;
          }
          this.$store.commit("routeChange", "end");
          this.progress = false;
        })
        .catch(error => {
          this.errorText = "Network Error";
          console.log("display Error" + this.errorText);
          this.$store.commit("routeChange", "end");
        });
      var self = this;

      console.log("this is panno", self.panno);
      if (self.panno === "") {
        self.creditPanFlag = true;
      }
      self.$store.commit("routeChange", "start");
      console.log("this is pan no", self.panno);
      const instance = axios.create({
        baseURL:
          "https://uatgateway.supermoney.in/credit-score/services/creditscore/",
        //   baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.28.53:8080/MintReliance/MintReliance/',
        headers: { "content-type": "application/json" }
      });

      //  var url = 'http://13.126.28.53:8080/MintReliance/MintReliance/kycCheck'
      var data = {
        customerId: this.$route.query.data,
        referenceType: "Customer"
      };
      instance
        .post("getLastCreditDetails", data)

        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          // if (JSONData.successFlag == true) {
          //
          //
          //     self.errorText = ''
          //     self.switchTabFive()
          //
          //
          //
          // }
          //
          // else {
          //     self.errorText = JSONData.data.message;
          //
          // }
          self.firstNameCredit = JSONData.firstName;
          self.surnameCredit = JSONData.surname;
          self.genderCredit = JSONData.gender;
          self.dateOfBirthCredit = JSONData.dateOfBirth;
          self.panNumberCredit = JSONData.panNumber;
          self.passportNumberCredit = JSONData.passportNumber;
          self.phoneNumberCredit = JSONData.phoneNumber;
          // self.emailidCredit =
          self.voterIdCredit = JSONData.voterId;
          self.creditAccountTotal = JSONData.creditAccountTotal;
          self.creditAccountActive = JSONData.creditAccountActive;
          self.creditAccountClosed = JSONData.creditAccountClosed;
          self.creditAccountDefault = JSONData.creditAccountDefault;
          self.dateReported = JSONData.reportDate;
          self.bureauScore = JSONData.bureauScore;
          self.bureauScoreConfidLevel = JSONData.bureauScoreConfidLevel;
          self.firstLineAddress = JSONData.firstLineAddress;
          self.cityCredit = JSONData.city;
          self.stateCredit = JSONData.state;
          self.pinCodeCredit = JSONData.pinCode;
          self.outstandingBalanceAll = JSONData.outstandingBalanceAll;
          self.outstandingBalanceSecured = JSONData.outstandingBalanceSecured;
          self.outstandingBalanceUnSecured =
            JSONData.outstandingBalanceUnSecured;
          self.cAPSLast7Days = JSONData.cAPSLast7Days;
          self.cAPSLast30Days = JSONData.cAPSLast30Days;
          self.cAPSLast90Days = JSONData.cAPSLast90Days;
          self.cAPSLast180Days = JSONData.cAPSLast180Days;
          self.enquiryDetails = JSONData.enquiryDetails;

          self.cityData = JSONData.accountDetails;
          self.companyNames = Object.keys(self.cityData);

          self.cityData.forEach(function (city) {
            if (
              !self.accountTypeDescriptionArray.includes(
                city.accountTypeDescription
              )
            ) {
              self.accountTypeDescriptionArray.push(
                city.accountTypeDescription
              );
            }
          });

          self.accountDetailsNew = self.cityData;

          for (var i = 0; i < self.companyNames.length; i++) {
            self.cityNamesComp = Object.keys(self.companyNames[i]);
            console.log("this are the keys", self.cityNamesComp);
          }

          self.$store.commit("routeChange", "end");
          self.progress = false;
        })
        .catch(function (error) {
          self.errorFlag = true;
          self.errorText = error.response.data.error;
          self.$store.commit("routeChange", "end");
        });
      console.log("this is first name", self.firstNameCredit);
      if (self.firstNameCredit === "" || self.firstNameCredit === undefined) {
        self.firstNameCreditFlag = true;
      }
    }
  },
  watch: {
    accountTypeDescription: function () {
      var tempArray = [];

      if (this.accountTypeDescription.length > 0) {
        for (var i = 0; i < this.cityData.length; i++) {
          if (
            this.cityData[i].accountTypeDescription ===
            this.accountTypeDescription
          ) {
            tempArray.push(this.cityData[i]);
          }
        }

        this.accountDetailsNew = tempArray;
      } else {
        this.accountDetailsNew = this.cityData;
      }
    },

    sortCredit: function () {
      console.log("this is the enered array");

      if (this.sortCredit === "Open Date") {
        this.accountDetailsNew.sort(
          (a, b) =>
            new Date(b.openDate).getTime() - new Date(a.openDate).getTime()
        );
      } else if (this.sortCredit === "Current Balance") {
        this.accountDetailsNew.sort(
          (a, b) => b.currentBalance - a.currentBalance
        );
      } else if (this.sortCredit === "Amount Due") {
        this.accountDetailsNew.sort(
          (a, b) => b.amountPastDue - a.amountPastDue
        );
      }
    }
  }
};
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {

    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

/*! rtl:end:ignore */
</style>
